"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 北京证券交易所申购
 */
var web_1 = __importDefault(require("../../config/web"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
loadstep();
loadcontent();
function loadstep() {
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_APPLYING_DATE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            pageSize: 50,
            source: "WEB",
            client: "WEB",
        }
    }).then(function (json) {
        var _a;
        if (json && json.result && json.result.data.length > 0) {
            var now = new Date();
            var m = now.getMonth() + 1;
            var d = now.getDate();
            var sysdate = now.getFullYear() + "" + (m < 10 ? ("0" + m) : m) + "" + (d < 10 ? ("0" + d) : d);
            var stepbox = $('.step');
            var item = json.result.data[0];
            var xjqsr = item.ENQUIRY_START_DATE.substring(0, 10).replace(/-/g, ''); //询价起始日
            $('.step1F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.ENQUIRY_START_DATE));
            if (xjqsr <= sysdate) {
                $('.step1F', stepbox).removeClass("left01").addClass("left03");
            }
            var xjjsr = item.ENQUIRY_END_DATE.substring(0, 10).replace(/-/g, ''); //询价结束日
            $('.step2F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.ENQUIRY_END_DATE));
            if (xjjsr <= sysdate)
                $('.step2F', stepbox).removeClass("center01").addClass("center05");
            var rgqsr = item.SUBSCRIBE_START_DATE.substring(0, 10).replace(/-/g, ''); //认购起始日
            $('.step3F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.SUBSCRIBE_START_DATE));
            if (rgqsr <= sysdate)
                $('.step3F', stepbox).removeClass("center01").addClass("center05");
            var rgjzr = item.SUBSCRIBE_END_DATE.substring(0, 10).replace(/-/g, ''); //认购截止日
            $('.step4F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.SUBSCRIBE_END_DATE));
            if (rgjzr <= sysdate)
                $('.step4F', stepbox).removeClass("center01").addClass("center05");
            var ssr = (_a = item.LISTING_DATE) === null || _a === void 0 ? void 0 : _a.substring(0, 10).replace(/-/g, ''); //上市日期
            $('.step5F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.LISTING_DATE));
            if (ssr <= sysdate)
                $('.step5F', stepbox).removeClass("right01").addClass("right02");
        }
    });
}
function loadcontent() {
    var table_jbxx = $("#table_jbxx");
    var table_bjdj = $("#table_bjdj");
    var table_mjqk = $("#table_mjqk");
    var table_zyrq = $("#table_zyrq");
    var table_rgfl = $("#table_rgfl");
    var table_srbx = $("#table_srbx");
    //基本信息
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_BS_BASICINFO",
            columns: "ALL",
            pageSize: 1,
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB"
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".SECURITY_CODE", table_jbxx).html(data.SECURITY_CODE); //证券代码	
            $(".SECURITY_NAME", table_jbxx).html(data.SECURITY_NAME); //基金名称	
            $(".SECURITY_NAME_ABBR", table_jbxx).html(data.SECURITY_NAME_ABBR); //基金简称	
            $(".SECURITY_TYPE", table_jbxx).html(data.SECURITY_TYPE); //基金类型	
            $(".OPERATE_WAY", table_jbxx).html(data.OPERATE_WAY); //运作方式
            $(".TRADE_PLACE", table_jbxx).html(fieldtools_1["default"].strformat(data.TRADE_PLACE)); //交易场所	
            $(".FOUND_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(data.FOUND_DATE, 'YYYY-MM-DD (周W)')); //成立日期	
            $(".DURATION_EXPIRE", table_jbxx).html(fieldtools_1["default"].strformat(data.DURATION_EXPIRE)); //存续期限	
            $(".NEW_SHARE", table_jbxx).html(fieldtools_1["default"].fieldfmt(data.NEW_SHARE, { trim: true })); //最新份额(亿份)
            $(".ALLOW_SCALE", table_jbxx).html(fieldtools_1["default"].fieldfmt(data.ALLOW_SCALE)); //规模(亿元)
            $(".CASH_INCOME", table_jbxx).html(fieldtools_1["default"].fieldfmt(data.CASH_INCOME)); //预计现金分派率	
            $(".YEARS", table_jbxx).html(data.YEARS); //年份	
            $(".MANAGEMENT_RATE", table_jbxx).html(data.MANAGEMENT_RATE); //管理费率	
            $(".TRUSTEE_RATE", table_jbxx).html(data.TRUSTEE_RATE); //托管费率	
            $(".PARTY_NAME_ABBR", table_jbxx).html(fieldtools_1["default"].strformat(data.PARTY_NAME_ABBR)); //管理人简称
            $(".MANAGER", table_jbxx).html(fieldtools_1["default"].strformat(data.MANAGER)); //基金经理	
            $(".CONTRACT_EXPIRE_EXPLAIN", table_jbxx).html(fieldtools_1["default"].strformat(data.CONTRACT_EXPIRE_EXPLAIN)); //合同期限说明	
            $(".LISTING_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(data.LISTING_DATE)); //上市日期	
            $(".FUND_MANAGER", table_jbxx).html(fieldtools_1["default"].strformat(data.FUND_MANAGER)); //基金管理人全称	
            $(".FUND_TRUSTEE", table_jbxx).html(fieldtools_1["default"].strformat(data.FUND_TRUSTEE)); //基金托管人
            $(".ORIGINAL_HOLDER", table_jbxx).html(fieldtools_1["default"].strformat(data.ORIGINAL_HOLDER)); //原始权益人	
            $(".ABS_MANAGER", table_jbxx).html(fieldtools_1["default"].strformat(data.ABS_MANAGER)); //资产支持证券管理人
            $(".ITEM_COMPANY", table_jbxx).html(fieldtools_1["default"].strformat(data.ITEM_COMPANY)); //项目公司	
            $(".ITEM_NAME", table_jbxx).html(fieldtools_1["default"].strformat(data.ITEM_NAME)); //项目名称	
            $(".ITEM_VALUATION", table_jbxx).html(data.ITEM_VALUATION == 0 ? '-' : fieldtools_1["default"].fieldfmt(data.ITEM_VALUATION, { trim: true })); //项目估值	
            $(".ITEM_TYPE", table_jbxx).html(fieldtools_1["default"].strformat(data.ITEM_TYPE)); //项目类型	
            $(".ABS_INNER_NAME", table_jbxx).html(fieldtools_1["default"].strformat(data.ABS_INNER_NAME)); //资产支持证券名称	 
            $(".OPERATE_MANAGER", table_jbxx).html(fieldtools_1["default"].strformat(data.OPERATE_MANAGER)); //项目运营方
        }
    });
    //投资目标
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_BS_BASICINFONCLOB",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB",
            pageSize: 1
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".INVEST_TARGET", table_jbxx).html(fieldtools_1["default"].strformat(data.INVEST_TARGET)); //投资目标
        }
    });
    //报价及定价
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_F9_QUOTEPRICE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB",
            pageSize: 1
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".ENQUIRY_DATE", table_bjdj).html(data.ENQUIRY_DATE); //询价时间
            $(".ENQUIRY_INTERVAL", table_bjdj).html(fieldtools_1["default"].strformat(data.ENQUIRY_INTERVAL)); //报价区间
            $(".DECLARE_OFFLINE_INVESTOR", table_bjdj).html(fieldtools_1["default"].strformat(data.DECLARE_OFFLINE_INVESTOR)); //参与申报的网下投资者总数
            $(".DECLARE_OBJECT", table_bjdj).html(fieldtools_1["default"].strformat(data.DECLARE_OBJECT)); //参与申报的配售对象总数
            $(".ENQUIRY_SUBSCRIBE_SHARE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.ENQUIRY_SUBSCRIBE_SHARE, { trim: true })); //拟认购份额总数(份)
            $(".SUBSCRIBE_SHARE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.SUBSCRIBE_SHARE, { trim: true })); //剔除无效报价后的拟认购份额总数(份)
            $(".SUBSCRIBE_MULTIPLE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.SUBSCRIBE_MULTIPLE, { num: 0, omit: false })); //剔除无效报价后的拟认购倍数
            $(".QUOTE_MEDIAN", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.QUOTE_MEDIAN, { trim: true })); //剔除无效报价后的报价中位数(元/份)
            $(".QUOTE_WEIGHTAVG", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.QUOTE_WEIGHTAVG, { trim: true })); //剔除无效报价后的报价加权平均数(元/份)
            $(".VALID_OFFLINE_INVESTOR", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.VALID_OFFLINE_INVESTOR, { num: true })); //有效报价投资者总数	
            $(".VALID_OBJECT", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.VALID_OBJECT, { trim: true })); //有效报价配售对象总数
            $(".VALID_SUBSCRIBE_SHARE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.VALID_SUBSCRIBE_SHARE, { trim: true })); //有效报价拟认购份额总数(份)
            $(".VALID_SUBSCRIBE_MULTIPLE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.VALID_SUBSCRIBE_MULTIPLE, { num: 2 })); //有效报价拟认购倍数
            $(".SALE_PRICE", table_bjdj).html(fieldtools_1["default"].fieldfmt(data.SALE_PRICE, { num: 3 })); //认购价格(元/份)
            table_bjdj.show();
        }
    });
    //募集情况
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_F9_RAISE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB",
            pageSize: 1
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".SALE_WAY", table_mjqk).html(data.SALE_WAY); //发售方式
            $(".TOTAL_SCALE", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.TOTAL_SCALE, { trim: true })); //发售份额总数(份)
            $(".STRATEGIC_RAISE_SHARE", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.STRATEGIC_RAISE_SHARE, { trim: true })); //初始战略配售数量(份)
            $(".STRATEGIC_TOTAL_RATIO", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.STRATEGIC_TOTAL_RATIO, { trim: true })); //初始战略配售数量占发售数比例(%)
            $(".OFFLINE_RAISE_SHARE", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.OFFLINE_RAISE_SHARE, { trim: true })); //初始网下发售数量(份)
            $(".OFFLINE_ISNTOTAL_RATIO", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.OFFLINE_ISNTOTAL_RATIO, { trim: true })); //初始网下发售数占扣除战略配售后发售数比例(%)
            $(".PUBLIC_SHARE", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.PUBLIC_SHARE, { trim: true })); //初始公众发售数量(份)
            $(".PUBLIC_ISNTOTAL_RATIO", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.PUBLIC_ISNTOTAL_RATIO, { trim: true })); //初始公众发售数占扣除战略配售后发售数比例(%)
            $(".OFFLINE_QUOTA_UPPER", table_mjqk).html(fieldtools_1["default"].strformat(data.OFFLINE_QUOTA_UPPER)); //网下认购最高额
            $(".OFFLINE_QUOTA_LOWER", table_mjqk).html(fieldtools_1["default"].strformat(data.OFFLINE_QUOTA_LOWER)); //网下认购最低额
            $(".OUTSIDE_PUBLICQUOTA_LOWER", table_mjqk).html(fieldtools_1["default"].strformat(data.OUTSIDE_PUBLICQUOTA_LOWER)); //公众投资者场外认购门槛
            $(".INSIDE_PUBLICQUOTA_LOWER", table_mjqk).html(fieldtools_1["default"].strformat(data.INSIDE_PUBLICQUOTA_LOWER)); //公众投资者场内认购门槛
            $(".PUBLICQUOTA_LOWER", table_mjqk).html(fieldtools_1["default"].strformat(data.PUBLICQUOTA_LOWER)); //公众投资者认购门槛(场所未知)
            $(".PREDICT_RAISE_SCALE", table_mjqk).html(fieldtools_1["default"].fieldfmt(data.PREDICT_RAISE_SCALE, { trim: true })); //预计募集资金总额(元)
            $(".PAY_CASH_RATE", table_mjqk).html(fieldtools_1["default"].strformat(data.PAY_CASH_RATE)); //预计现金分派率           
            table_mjqk.show();
        }
    });
    //发行重要日期
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_F9_DATE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB",
            pageSize: 1
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".RPRONOTIDATE", table_zyrq).html(fieldtools_1["default"].dateformat(data.RPRONOTIDATE)); //招募说明书披露日 
            $(".RINQNOTIDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.RINQNOTIDATE)); //询价公告披露日     
            $(".ROFFRSDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.ROFFRSDATE)); //网下路演日     
            $(".RINQDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.RINQDATE)); //询价日     
            $(".RPLAREQDATE", table_zyrq).html(fieldtools_1["default"].dateformat(data.RPLAREQDATE)); //获配结果查询日     
            $(".RSALENOTIDATE", table_zyrq).html(fieldtools_1["default"].dateformat(data.RSALENOTIDATE)); //基金份额发售公告披露日     
            $(".RSTRAISEDATE", table_zyrq).html(fieldtools_1["default"].dateformat(data.RSTRAISEDATE)); //募集期起始日     
            $(".REDRAISEDATE", table_zyrq).html(fieldtools_1["default"].dateformat(data.REDRAISEDATE)); //募集期截止日
            $(".ROFFPAYDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.ROFFPAYDATE)); //网下认购日及缴款日     
            $(".RPUBPAYDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.RPUBPAYDATE)); //公众认购日及缴款日     
            $(".RSTRABUYDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.RSTRABUYDATE)); //战略投资认购日     
            $(".RSTRAERPAYDATE", table_zyrq).html(fieldtools_1["default"].strformat(data.RSTRAERPAYDATE)); //战略投资者缴款日     
            table_zyrq.show();
        }
    });
    //认购费率
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_F9_SUBSCRIBEFEERATE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")(OBJECT<>\"null\")",
            sortColumns: "OBJECT,PLA",
            sortTypes: "1,1",
            client: "WEB",
            source: "WEB"
        }
    }).then(function (json) {
        var list = [];
        if (json && json.result && json.result.data.length > 0) {
            $("tr:nth(1)", table_rgfl).remove();
            $(".headTitle", table_rgfl).attr("rowspan", json.result.data.length + 1);
            for (var i = 0; i < json.result.data.length; i++) {
                var item = json.result.data[i];
                if (json.result.data[i].OBJECT != null) {
                    var tr = '<tr>';
                    tr += '<td>' + fieldtools_1["default"].strformat(item.OBJECT_NAME) + '</td>';
                    tr += '<td>' + fieldtools_1["default"].strformat(item.PLA) + '</td>';
                    tr += '<td>' + fieldtools_1["default"].strformat(item.REITS_SUBSCRIBE_RATE) + '</td>';
                    tr += '<td>' + fieldtools_1["default"].strformat(item.RATE_U) + '</td>';
                    tr += '</tr >';
                    table_rgfl.append($(tr));
                }
            }
        }
        else
            table_rgfl.hide();
    });
    //首日表现
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: "RPT_REITS_APPLYING_PERFORMANCE",
            columns: "ALL",
            filter: "(SECURITY_CODE=\"" + scode + "\")",
            client: "WEB",
            source: "WEB",
            pageSize: 1
        }
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".LD_OPEN_PRICE", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_OPEN_PRICE, { num: 3 })); //首日开盘价	
            $(".LD_CLOSE_PRICE", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_CLOSE_PRICE, { num: 3 })); //首日收盘价	
            $(".LD_OPEN_PREMIUM", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_OPEN_PREMIUM, { num: 2 })); //首日开盘涨幅
            $(".LD_CLOSE_CHANGE", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_CLOSE_CHANGE, { num: 2 })); //首日收盘涨幅
            $(".LD_TURNOVERRATE", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_TURNOVERRATE, { num: 2 })); //首日换手率	
            $(".LD_HIGH_CHANG", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_HIGH_CHANG, { num: 2 })); //首日最高涨幅
            $(".LD_AVERAGE_CHANG", table_srbx).html(fieldtools_1["default"].fieldfmt(data.LD_AVERAGE_CHANG, { num: 2 })); //首日平均涨幅
            table_srbx.show();
        }
    });
    //最新公告
    $("#dataview_zxgg").emdataview({
        dataurl: {
            hostname: "anoticeurl",
            url: "api/security/ann",
            params: {
                ann_type: "",
                client_source: 'web',
                market_stock_list: "150." + scode
            }
        },
        ajaxoptions: { jsonp: "cb" },
        totalfield: "data.total_hits",
        datafield: "data.list",
        pagesize: 5,
        allcolumnhover: false,
        urlkeyvalues: {
            pagenumber: "page_index",
            pagesize: "page_size",
            sortname: "st",
            sortorder: "sr"
        },
        columns: {
            title: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis\" style=\"width:600px;\" href=\"//fund.eastmoney.com/gonggao/" + scode + "," + item.art_code + ".html\" title=\"" + value + "\">" + value + "</a>";
                }
            },
            column_name: {
                formatter: function (value, item, i, field) {
                    var _a;
                    return ((_a = item.columns[0]) === null || _a === void 0 ? void 0 : _a.column_name) || '-';
                }
            },
            notice_date: emfield.date
        }
    });
}
